export default [
    {
        path: "/admin/job-titles",
        name: "job-title",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/job-title")
    }
];
